module.exports = __webpack_public_path__ + "img/CC2014.06ceb210.png";